import { render, staticRenderFns } from "./ReportUser.vue?vue&type=template&id=76063a3e&scoped=true"
import script from "./ReportUser.vue?vue&type=script&lang=js"
export * from "./ReportUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76063a3e",
  null
  
)

export default component.exports